import { render, staticRenderFns } from "./updateBranchLocation.vue?vue&type=template&id=3d686f14&"
import script from "./updateBranchLocation.vue?vue&type=script&lang=js&"
export * from "./updateBranchLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports